import { render } from "./locationRed.vue?vue&type=template&id=5955c27e"
import script from "./locationRed.vue?vue&type=script&lang=js"
export * from "./locationRed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__